import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_REPORTS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_REPORT:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_REPORT:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_REPORT:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_REPORT:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
